import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Gunakan localStorage
import { combineReducers } from "redux";
import authReducer from "../redux/authSlice"; // ✅ Pastikan ini benar!
import CustomizerReducer from "./customizer/CustomizerSlice";
import ChatsReducer from "./apps/chat/ChatSlice";
import NotesReducer from "./apps/notes/NotesSlice";
import EmailReducer from "./apps/email/EmailSlice";
import TicketReducer from "./apps/tickets/TicketSlice";
import ContactsReducer from "./apps/contacts/ContactSlice";
import EcommerceReducer from "./apps/eCommerce/EcommerceSlice";
import UserProfileReducer from "./apps/userProfile/UserProfileSlice";
import BlogReducer from "./apps/blog/BlogSlice";
import UserReducer from "./managements/users/UserSlice"; 
import RoleReducer from "./managements/roles/RoleSlice";
import EmailTemplateReducer from "./managements/email-templates/EmailTemplateSlice";
import EmailScheduleReducer from "./managements/email-schedules/EmailScheduleSlice";
import EmailRecipientsReducer from "./managements/email-recipients/EmailRecipientsSlice";
import BusinessReducer from "./managements/business/BusinessSlice"; 
import VendorReducer from "./managements/vendors/VendorSlice"; 
import MaterialReducer from "./managements/materials/MaterialSlice"; 
import SystemReducer from "./managements/systems/SystemSlice";
import MenuMasterReducer from "./managements/menu-master/MenuMasterSlice"; 
import MasterGroupingsReducer from "./settings/mastergroupings/MastergroupingSlice"; 
import RolesPermissionReducer from "./settings/rolepermissions/RolepermissionSlice";
import ForecastReducer from "./managements/forecasts/ForecastSlice"; 
import ForecastSupplierReducer from "./managements/forecastsuppliers/ForecastsupplierSlice"; 
import DashboardReducer from "./managements/dashboards/DashboardSlice"; 
import MonitoringReducer from "./managements/monitorings/MonitoringSlice"; 
import InventoryReducer from "./managements/inventorys/InventorySlice"; 

import EwsReportReducer from "./managements/ewsreports/EwsreportSlice"; 
import StockReportReducer from "./managements/stockreports/StockreportSlice"; 
import FourmReportReducer from "./managements/fourmreports/FourmreportSlice"; 
import LoginActivityReducer from "./managements/login-activity/LoginActivitySlice";
import EmailLogReducer from "./managements/email-log/EmailLogSlice"; 

// ✅ Konfigurasi Redux Persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "customizer", "ecommerceReducer", "userpostsReducer"], // ✅ Pastikan `auth` ada di sini!
};

// ✅ Gabungkan semua reducer menjadi satu rootReducer
const rootReducer = combineReducers({
  auth: authReducer, // 🔥 Tambahkan authReducer
  customizer: CustomizerReducer,
  chatReducer: ChatsReducer,
  emailReducer: EmailReducer,
  notesReducer: NotesReducer,
  contactsReducer: ContactsReducer,
  ticketReducer: TicketReducer,
  ecommerceReducer: EcommerceReducer,
  userpostsReducer: UserProfileReducer,
  blogReducer: BlogReducer,
  userReducer:UserReducer,
  roleReducer:RoleReducer,
  emailTemplateReducer:EmailTemplateReducer,
  emailScheduleReducer:EmailScheduleReducer,
  emailRecipientsReducer:EmailRecipientsReducer,
  businessReducer:BusinessReducer,
  vendorReducer:VendorReducer,
  mastergroupingReducer:MasterGroupingsReducer,
  rolepermissionReducer:RolesPermissionReducer,
  forecastReducer:ForecastReducer,
  materialReducer: MaterialReducer,
  forecastsupplierReducer: ForecastSupplierReducer,
  dashboardReducer:DashboardReducer,
  monitoringReducer:MonitoringReducer,
  inventoryReducer:InventoryReducer,
  ewsreportReducer:EwsReportReducer,
  stockreportReducer:StockReportReducer,
  fourmreportReducer:FourmReportReducer,
  systemReducer:SystemReducer,
  menuMasterReducer:MenuMasterReducer,
  loginActivityReducer:LoginActivityReducer,
  emailLogReducer:EmailLogReducer
});

// ✅ Bungkus rootReducer dengan persistReducer agar data bisa disimpan
const persistedReducer = persistReducer(persistConfig, rootReducer);

// ✅ Konfigurasi Redux Store dengan persistedReducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // ✅ Hindari warning terkait serialisasi di Redux Persist
    }),
});

// ✅ Buat persistor untuk Redux Persist
export const persistor = persistStore(store);

export default store;
